import { onAuthStateChanged, User } from "firebase/auth";
import { auth } from "firebaseConfig";
import { useEffect, useState } from "react";

const useLoginUser = () => {
    const [user, setUser] = useState<User | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const getLoginUser = (): Promise<User | null> =>
        new Promise((resolve) => {
            onAuthStateChanged(auth, (u) => {
                resolve(u);
            });
        });

    useEffect(() => {
        (async () => {
            const user = await getLoginUser();
            setUser(user);
            setIsLoading(false);
        })();
    }, []);

    return { user, isLoading };
};

export default useLoginUser;
